import { useState } from 'react';
import ICartItem from '~domain/entities/CartItem/ICartItem';

export interface IUseRemove {
    cartItem: ICartItem;
    removeFreeItems: boolean;
    onRemoveItem?(cartItem: ICartItem): Promise<void>;
}

export const useRemove = (props: IUseRemove) => {
    const { cartItem, removeFreeItems, onRemoveItem } = props;
    const [isRemoving, setIsRemoving] = useState(false);
    const { product, isAutomaticOffer } = cartItem;
    const pricedSku = !product.isSample && !cartItem.isGiftItem && cartItem.unitPriceWithTax !== 0;

    const showRemove = !isAutomaticOffer && (pricedSku || (removeFreeItems && !pricedSku));

    const onRemovedItem = () => {
        if (onRemoveItem) {
            setIsRemoving(true);
            onRemoveItem(cartItem).then(() => {
                setIsRemoving(false);
            });
        }
    };

    const onKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
        const enterKeyCode = 13;
        if (e.which === enterKeyCode) {
            onRemovedItem();
        }
    };

    return {
        isRemoving,
        onKeyPress,
        onRemovedItem,
        showRemove
    };
};
